import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useScreenStore, useMainStore, useSnapshotStore } from '@/store'
import { LOCALSTORAGE_KEY_DISCARDED_DB } from '@/configs/storage'
import { deleteDiscardedDB } from '@/utils/database'
import { getQueryString } from "@/utils/common";

import { isPC } from './utils/common'
import Tourists from './views/Editor/tourists.vue'
import Editor from './views/Editor/index.vue'
import Screen from './views/Screen/index.vue'
import Mobile from './views/Mobile/index.vue'

import Cookies from 'js-cookie'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const _isPC = isPC()

const mainStore = useMainStore()
const snapshotStore = useSnapshotStore()
const { databaseId } = storeToRefs(mainStore)
const { screening } = storeToRefs(useScreenStore())

const { locale } = useI18n()
const urlSearch = window.location.search
const touristCome = getQueryString('shareId', urlSearch)
const cacheLang = Cookies.get('lang') || getQueryString('lang', urlSearch) || 'en'
//const cacheLang = localStorage.getItem('lang')
// locale.value = cacheLang ? cacheLang : navigator.language
locale.value = cacheLang ? cacheLang : 'en'



if (process.env.NODE_ENV !== 'production') {
}

onMounted(async () => {
  await deleteDiscardedDB()
  snapshotStore.initSnapshotDatabase()
  mainStore.setAvailableFonts()

})

// 应用注销时向 localStorage 中记录下本次 indexedDB 的数据库ID，用于之后清除数据库
window.addEventListener('unload', () => {
  const discardedDB = localStorage.getItem(LOCALSTORAGE_KEY_DISCARDED_DB)
  const discardedDBList: string[] = discardedDB ? JSON.parse(discardedDB) : []

  discardedDBList.push(databaseId.value)

  const newDiscardedDB = JSON.stringify(discardedDBList)
  localStorage.setItem(LOCALSTORAGE_KEY_DISCARDED_DB, newDiscardedDB)
})

return (_ctx: any,_cache: any) => {
  return (_unref(screening))
    ? (_openBlock(), _createBlock(Screen, { key: 0 }))
    : (_unref(touristCome))
      ? (_openBlock(), _createBlock(Tourists, { key: 1 }))
      : (_unref(_isPC))
        ? (_openBlock(), _createBlock(Editor, { key: 2 }))
        : (_openBlock(), _createBlock(Mobile, { key: 3 }))
}
}

})